export { default } from './GroupSearchFeedback';



// WEBPACK FOOTER //
// ./app/components/GroupSearchFeedback/index.js